<script lang="ts" setup>
import type { CollectionConfig } from '~/types'

const { index = 0, item, collection } = defineProps<{ collection: CollectionConfig, item: any, index?: number }>()
</script>

<template>
  <template v-if="getItemRoute(collection, item)">
    <NuxtLink
      :id="`tabpanel-${collection.collection}-${index + 1}`"
      :to="getItemRoute(collection, item)"
      class="w-full flex justify-center items-center"
    >
      <ImageFull
        :id="item.id"
        loading="lazy"
        :alt="item.name"
        :src="item.logo"
        :collection-id="item.collectionId"
        class="w-64 h-64 object-contain"
      />
    </NuxtLink>
  </template>
  <template v-else>
    <div
      :id="`tabpanel-${collection}-${index + 1}`"
      class="w-full flex justify-center items-center"
    >
      <ImageFull
        :id="item.id"
        loading="lazy"
        :alt="item.name"
        :src="item.logo"
        :collection-id="item.collectionId"
        class="w-64 h-64 object-contain"
      />
    </div>
  </template>
</template>
